import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

type PieData = {
  label: string;
  value: number;
  color: string;
};

type PieChartProps = {
  data: PieData[];
  width?: number;
  height?: number;
};

const PieChart: React.FC<PieChartProps> = ({
  data,
  width = 200,
  height = 200,
}) => {
  const ref = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (!ref.current) return;

    const radius = Math.min(width, height) / 2;

    // Clear previous render
    const svg = d3
      .select(ref.current)
      .attr("width", width)
      .attr("height", height);

    svg.selectAll("*").remove();

    const container = svg
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    const pie = d3
      .pie<PieData>()
      .value((d) => d.value)
      .sort(null);

    const arc = d3
      .arc<d3.PieArcDatum<PieData>>()
      .innerRadius(radius * 0.7)
      .outerRadius(radius);

    const arcs = container.selectAll("g").data(pie(data)).enter().append("g");

    arcs
      .append("path")
      .attr("d", arc)
      .attr("fill", (d) => d.data.color)
      .attr("stroke", "#fff")
      .style("stroke-width", "2px");

    // Center text (total)
    const total = d3.sum(data, (d) => d.value);

    container
      .append("text")
      .attr("text-anchor", "middle")
      .attr("dy", "0.35em")
      .style("font-size", "28px")
      .style("font-weight", "bold")
      .text(total);
  }, [data, width, height]);

  return <svg ref={ref} />;
};

export default PieChart;
